import { Post } from "../../../../types";
import { AlertTriangle, UserCheck } from "react-feather";
import { useEffect, useState } from "react";
import { useAuth } from "../../../../global-components/src";
import { User } from "../../../../global-components/src/types";
import { t } from "i18next";

interface PostProps{
    post?: Post;
    user?: User;
    onReport: (removeReport: boolean, id_user?: number, id_post?: number) => void;
    alreadyReported?: boolean;
}

const Report: React.FC<PostProps> = ({ post, onReport, user, alreadyReported = false }) => {
    const [isReported, setIsReported] = useState(alreadyReported);
    const { isAuthenticated, user: authUser } = useAuth();

    const handleReport = () =>{
        // setIsReported(!isReported)
        if(!isReported)
            onReport(false, user?.id, post?.id);
    }

    const removeReport = () =>{
        onReport(true, user?.id, post?.id);
    }

    useEffect(() => {
        setIsReported(alreadyReported);
    }, [alreadyReported]);

    return (
        <>
        {isAuthenticated && user?.id != authUser?.id && !isReported ? (
            <>
            {!isReported ? (
                <li>
                    <span className="dropdown-item cursor-pointer user-select-none" onClick={() => { handleReport() }}>
                        <div 
                            style={{color: "#ff0018",    fontWeight: 600 }}
                            {...(!isReported ? { "data-bs-toggle": "modal", "data-bs-target": "#report-user" } : {})}
                            className="div-icon-fix" onClick={removeReport}>

                            {!isReported ? (
                                <><AlertTriangle data-feather="paperclip" data-type="unfix" className="icon-config-post"/>{t("post.actions.report")} </>
                            ) : (
                                <><UserCheck data-feather="paperclip" data-type="fix" className="icon-config-post"/>{t("post.actions.removeReport")} </>
                            )}
                        </div> 
                    </span>
                </li>

            ): null}
            </>
        ) : null}
        
        </>
    );
};

export default Report;
